import * as types from './constants';

// Create Shopify Token
export const createShopifyTokenRequest = data => (
  { type: types.CREATE_SHOPIFY_TOKEN_REQUEST, payload: data }
);

export const createShopifyTokenDone = data => (
  { type: types.CREATE_SHOPIFY_TOKEN_DONE, payload: data }
);

export const createShopifyTokenFailed = errors => (
  { type: types.CREATE_SHOPIFY_TOKEN_FAILED, payload: errors }
);

export const createShopifyTokenReset = () => (
  { type: types.CREATE_SHOPIFY_TOKEN_RESET }
);